export default __webpack_public_path__ + "static/media/DSC.ff3cebab.jpg";